import { useEffect, useState } from "react";
import { ArrowLeft, Search, X } from 'lucide-react';
import { CategoryResponse } from '@/js/repository/CategoryRepository';
import { getCategoryPath } from '@/js/utils/stringUtils';
import { useTranslation } from "react-i18next";
import Header from "./Header";
import { SiteInfo } from "@/globals";

export default function Layout({ children, categories }: any) {
  const [showModal, setShowModal] = useState(false);
  const [showSearchModal, setShowSearchModal] = useState(false);
  const { t } = useTranslation();
  const safeCategories = categories || [];
  
  return (
    <>
      <Header categories={safeCategories} setShowModal={setShowModal} setShowSearchModal={setShowSearchModal} />
      
      <main className="mx-auto min-h-[calc(100vh-72px-120px)] max-w-[1360px] px-4 pb-10 pt-[92px] sm:px-6 lg:px-8">
        { children }
      </main>

      {showModal && (
        <div className="fixed inset-0 z-50 bg-[#101820]/60 text-[#101820] backdrop-blur-sm">
          <div className="h-full w-full overflow-auto bg-[#f7f4ef] p-6">
            <button
              onClick={() => setShowModal(false)}
              className="absolute right-4 top-4 inline-flex h-10 w-10 items-center justify-center rounded-lg border border-black/10 bg-white"
              title={t("close")}
            >
              <X size={24} />
            </button>
            <a href="/" className="mb-8 flex items-center gap-3" onClick={() => setShowModal(false)}>
              <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-[#101820] text-lg font-black text-white">P</span>
              <span>
                <span className="block text-2xl font-black">{SiteInfo.siteName}</span>
                <span className="block text-xs font-semibold text-[#fd384f]">{SiteInfo.tagline}</span>
              </span>
            </a>

            <div className="grid gap-2 text-lg font-bold">
              <a href="/" className="rounded-lg bg-white px-4 py-3" onClick={() => setShowModal(false)}>{t("hotDeals")}</a>
              <a href="/brands" className="rounded-lg bg-white px-4 py-3" onClick={() => setShowModal(false)}>{t("brands")}</a>
              <a href="/promotions" className="rounded-lg bg-white px-4 py-3" onClick={() => setShowModal(false)}>{t("promotions")}</a>
            </div>

            <ul className="mt-6 grid grid-cols-2 gap-2">
              {safeCategories.map((category: CategoryResponse) => (
                <li key={category.id}>
                  <a className="block rounded-lg border border-black/10 bg-white px-3 py-3 text-sm font-semibold" href={getCategoryPath(category.id, category.name)} onClick={() => setShowModal(false)}>{category.name}</a>
                </li>
              ))}
            </ul>
          </div>
        </div>
      )}

      {showSearchModal && (
        <div className="fixed inset-0 z-50 bg-[#101820]/70 text-white backdrop-blur-sm">
          <div className="flex h-[72px] w-full flex-wrap items-center border-b border-white/10 bg-[#101820]">
            <button
              onClick={() => setShowSearchModal(false)}
              className="mx-4 inline-flex h-10 w-10 items-center justify-center rounded-lg border border-white/20"
              title={t("close")}
            >
              <ArrowLeft size={24} />
            </button>

            <form action="/search" method="get" className="flex flex-grow items-center pr-4">
              <input
                type="search"
                name="q"
                className="h-11 w-full rounded-lg bg-white px-4 text-black outline-none ring-2 ring-transparent focus:ring-[#fd384f]"
                placeholder={t("search")}
                autoFocus
              />

              <button
                type="submit"
                className="ml-3 inline-flex h-10 w-10 items-center justify-center rounded-lg bg-[#fd384f]"
                title={t("search")}
              >
                <Search size={20} />
              </button>

            </form>
          </div>
          <div className="h-[calc(100%-72px)] w-full overflow-auto p-6">
            <p className="mb-3 text-sm font-semibold text-white/70">{t("otherCategories")}</p>
            <ul className="flex flex-wrap gap-2">
              {safeCategories.slice(0, 12).map((category: CategoryResponse) => (
                <li key={category.id}>
                  <a className="block rounded-lg bg-white/10 px-3 py-2 text-sm font-semibold hover:bg-white/20" href={getCategoryPath(category.id, category.name)} onClick={() => setShowSearchModal(false)}>
                    {category.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
      )}
    </>
  );
}
